export enum ExpansionState {
  Collapsed = "collapsed",
  Expanded = "expanded",
  Indeterminate = "indeterminate",
}
